import React, {useEffect, useState} from 'react';
import {X} from "react-feather";
import {
    deleteConversationAccountDelete,
    getVendorAccounts,
    postConversationAccountAdd
} from "../../services/api/messaging";
import {BROKER, VENDOR} from "../../services/constants/CompanyType";
import AccountItem from "../Item/AccountItem";
import AccountSearch from "../Input/AccountSearch";
import {Spinner} from "flowbite-react";
import {
    CONVERSATION_RELOAD,
    MESSAGE_RELOAD,
} from "../../services/events";

const ModalConversationUsers = ({
                                    authData,
                                    conversation,
                                    participants,
                                    onHandleToggle,
                                    onConversationSyncUsers
                                }) => {
    const [allVendorAccounts, setAllVendorAccounts] = useState(null);

    useEffect(() => {
        const fetchAllVendorAccounts = async () => {
            try {
                return await getVendorAccounts(authData.company.id);
            } catch (error) {
                console.error('Error fetching vendor accounts:', error);
            }
        }

        if (!allVendorAccounts && authData.type === VENDOR) {
            fetchAllVendorAccounts().then((accounts) => {
                setAllVendorAccounts(accounts);
            });
        }
    }, [allVendorAccounts, authData.company.id, authData.type]);

    const handleSyncUsers = () => {
        onConversationSyncUsers();
        onHandleToggle();
    };

    const handleAddVendorAccount = async (id) => {
        try {
            await postConversationAccountAdd(conversation.id, id)
            onConversationSyncUsers();
            const activeConversationChangedEvent = new Event(MESSAGE_RELOAD);
            document.dispatchEvent(activeConversationChangedEvent);

            const reloadEvent = new Event(CONVERSATION_RELOAD);
            document.dispatchEvent(reloadEvent);

        } catch (error) {
            console.error('Error fetching messages:', error);
        }
    };
    const handleRemoveVendorAccount = async (id) => {
        try {
            const res = await deleteConversationAccountDelete(conversation.id, id);
            onConversationSyncUsers();
            const activeConversationChangedEvent = new Event(MESSAGE_RELOAD);
            document.dispatchEvent(activeConversationChangedEvent);

            const reloadEvent = new Event(CONVERSATION_RELOAD);
            document.dispatchEvent(reloadEvent);

            if (res.message) {
                if (authData.id === id) {

                    onHandleToggle();
                }
            }
        } catch (error) {
            console.error(error);
        }
    }


    return (
        <div className="">
            <div
                className="sl-modal-header sl-rounded-md sl-flex sl-justify-between sl-bg-gray-50 sl-text-gray-900 sl-px-6 sl-py-16 sl-border-bottom">
                <div className="sl-font-semibold sl-text-lg sl-mr-auto sl-ml-0">
                    <span>Participants</span>
                </div>
                <div className="sl-cursor-pointer sl-btn-link-gray sl-mr-0" onClick={onHandleToggle}>
                    <X/>
                </div>
            </div>
            {(authData.type === VENDOR) && !allVendorAccounts && <div
                className="sl-modal-body   sl-px-6 sl-pb-0 sl-pt-24">
                <Spinner/></div>}
            {(authData.type === VENDOR) && allVendorAccounts &&
                <AccountSearch
                    participants={participants}
                    conversation={conversation}
                    allVendorAccounts={allVendorAccounts}
                    onRemoveVendorAccount={handleRemoveVendorAccount}
                    onAddVendorAccount={handleAddVendorAccount}/>}

            {(authData.type === BROKER) &&
                <div
                    className="sl-modal-body sl-h-auto sl-px-6 sl-pb-0 sl-pt-24 sl-flex sl-flex-col ">
                    <span
                        className="sl-text-gray-900 sl-font-regular sl-text-lg sl-pb-8"><span
                        className={"sl-font-medium"}>{participants.length}</span> people are in this conversation.</span>


                    <div className={"sl-flex sl-flex-col sl-gap-4"}>{participants.map((account, index) => (
                        <div
                            key={index}
                            rel={account.id}
                            className='sl-pl-0 sl-py-2 sl-flex sl-border-bottom-not-last sl-pb-3-not-last sl-rounded-lg sl-w-fill-available sl-justify-space-between sl-align-center'>
                            <div className="sl-flex sl-avatar-label-group sl-justify-start sl-align-center">
                                <AccountItem account={account} company={conversation[account.type]}/>
                            </div>
                        </div>))}
                    </div>
                </div>}
            <div className="sl-modal-footer sl-px-6 sl-py-32">
                <div
                    className="sl-flex sl-justify-end sl-gap-2-point-5 sl-bg-white sl-rounded-bottom-left-xl sl-rounded-bottom-right-xl sl-mt-0i sl-font sl-text-md sl-font-normal">
                    <button onClick={handleSyncUsers}
                            className="sl-btn sl-btn-primary sl-btn-lg sl-rounded-lg ">
                        Done
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModalConversationUsers;
